<template>
    <div class="footer">
      <div class="footer-content">
        <div class="logo">
          <img class="logo-img" src="@/assets/footer-logo.svg" alt="">
          <div class="logo-desc">有料、有趣、有温度的病理成长社群</div>
        </div>
        <div class="contact-us">
          <div class="title contact-title">联系我们</div>
          <div class="contact-detail">
            <div class="detail-item tel">电话：400-086-6212</div>
            <div class="detail-item address">上海中心：上海市宝山区园康路300号BC幢8层</div>
            <div class="detail-item address">北京中心：北京市大兴区生物医药产业基地永大路38号院6幢3层</div>
            <div class="detail-item emial">邮箱：service@histo.cn</div>
          </div>
        </div>
        <div class="product">
          <div class="title product-title">衡道旗下产品</div>
          <div class="product-detail">
            <a class="detail-item" target="_blank" href="https://www.histomed.com/">衡道病理官网</a>
            <a class="detail-item" target="_blank" href="https://wispath.histo.cn">远程会诊</a>
          </div>
        </div>
        <div class="QR-code">
          <div class="img-box">
            <img class="code-img" src="@/assets/qr-code1.svg" alt="">
            <div>关注公众号</div>
          </div>
          <div class="img-box">
            <img class="code-img" src="@/assets/H5img.png" alt="">
            <div>扫码进入H5手机端</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
         <div>Copyright &copy; 2017 - 2020&nbsp;&nbsp;衡道医学病理诊断中心&nbsp;&nbsp;All Rights Reserved&nbsp;&nbsp;<a
              style="text-decoration: none;"
              href="http://www.beian.miit.gov.cn/"
              target="_blank">沪ICP备11027485号-10</a>&nbsp;&nbsp;

               <a
              style="text-decoration: none;"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302006007"
              target="_blank"><img src="@/assets/wanganbeian.png"/>
              沪公网安备 31011302006007号
            </a>
            <a
                  style="text-decoration: none;"
                  href="https://tsm.miit.gov.cn/dxxzsp/"
                  target="_blank">
              增值电信业务经营许可证：沪B2-20200747
            </a>
        </div>
        <!-- <div class="company">Copyright 2018-2020 上海衡道病理</div> -->
        <!-- <a class="record" href="">沪公网安备 100262622215512号</a> -->
      </div>
    </div>
</template>

<script>
export default {
  name: 'htFooter'
}
</script>

<style scoped lang="scss">
.footer{
  height:262px;
  width:100%;
  background: #333333;
  .footer-content{
    width:1200px;
    height:212px;
    margin:0 auto;
    border-bottom: 1.4px solid rgba(255, 255, 255, 0.2);
    display:flex;
    color: rgba(240, 245, 250, 0.6);
    font-size:14px;
    .logo{
      width:226px;
      margin-top: 67px;
      margin-right:10px;
      letter-spacing: 0px;
      .logo-img{
        width: 212px;
        height:42px;
        margin-bottom:21px;
      }
    }
    .contact-us{
      width: 450px;
      margin-right:10px;
      margin-left: 70px;
      margin-top:73px;
    }
    .product{
      width:124px;
      margin-right:54px;
      margin-top:73px;
      .product-detail{
        a{
          display:block;
          color: rgba(240, 245, 250, 0.6);
          &:hover{
            color:#fff;
          }
        }
      }
    }
    .QR-code{
      width:256px;
      margin-top:67px;
      display:flex;
      .img-box{
        width:120px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .img-box:nth-child(1){
        margin-right:20px;
      }
      img{
          width:75px;
          margin-bottom:23px;
        border-radius: 4px;
        }
    }
    // 公共样式
    .detail-item{
      margin-bottom:6px;
      line-height:17px;
    }
    .title{
    font-size:16px;
    line-height:16px;
    margin-bottom:14px;
    }
  }
  .footer-bottom{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:13px;
    line-height:14px;
    font-size:14px;
    color: rgba(240, 245, 250, 0.2);
    a{
    color: rgba(240, 245, 250, 0.2);
    margin-left: 18px;
    }
    img{
      width:16px;
      margin-right:3px;
    }
    .company{
      // padding-right: 22px;
      // border-right: 1px solid rgba(240, 245, 250, 0.2);
    }
    .record{
      color: rgba(240, 245, 250, 0.2);
      padding-left: 22px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue